import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { isReadable } from '@ctrl/tinycolor';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SplashLabel',
  props: {
    label: { default: null },
    backgroundColor: { default: null }
  },
  setup(__props: any) {

const props = __props as { label: string | null, backgroundColor: string | null }




const colorStyling = () => {
    return {
        'background-color': props.backgroundColor ?? null,
        color: bestTextColor.value,
    };
};

const bestTextColor = computed(() => {
    if (props.backgroundColor) {
        return isReadable(props.backgroundColor, '#000') ? 'black' : 'white';
    }
    return 'black';
});


return (_ctx: any,_cache: any) => {
  return (__props.label)
    ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        class: "italic flex items-center px-x2 py-2 o-text-caption",
        style: _normalizeStyle(colorStyling())
      }, _toDisplayString(__props.label), 5))
    : _createCommentVNode("", true)
}
}

})